<template>
  <div class="formContent">
    <div class="form">
      <ul class="header">
      </ul>
    </div>
    <div class="content">
      <img src="../assets/array1.png" alt="">
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr class="titleTd " :class="index % 2 ? 'titleTd1' : 'titleTd'" v-for="(item, index) in array1" :key="item.id">
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3">{{ item.activeUserResidue }}</td>
          <td class="item4">{{ item.endDate }}</td>
          <td class="item5" v-if="timestamp > item.starTime && item.endTime > timestamp" @click="onApplication(item)">报名
          </td>
          <td class="item6" v-if="timestamp < item.starTime" @click="unopened()">未开始</td>
          <td class="item6" v-if="timestamp > item.endTime" @click="endTime()">已结束</td>
        </tr>
      </table>
    </div>
    <div class="content">
      <img src="../assets/array2.png" alt="">
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr class="titleTd " :class="index % 2 ? 'titleTd1' : 'titleTd'" v-for="(item, index) in array2" :key="item.id">
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3">{{ item.activeUserResidue }}</td>
          <td class="item4">{{ item.endDate }}</td>
          <td class="item5" v-if="timestamp > item.starTime && item.endTime > timestamp" @click="onApplication(item)">报名
          </td>
          <td class="item6" v-if="timestamp < item.starTime" @click="unopened()">未开始</td>
          <td class="item6" v-if="timestamp > item.endTime" @click="endTime()">已结束</td>
        </tr>
      </table>
    </div>
    <div class="content">
      <img src="../assets/array3.png" style="width: 30%;" alt="">
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr class="titleTd " :class="index % 2 ? 'titleTd1' : 'titleTd'" v-for="(item, index) in array3" :key="item.id">
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3">{{ item.activeUserResidue }}</td>
          <td class="item4">{{ item.endDate }}</td>
          <td class="item5" v-if="timestamp > item.starTime && item.endTime > timestamp" @click="onApplication(item)">报名
          </td>
          <td class="item6" v-if="timestamp < item.starTime" @click="unopened()">未开始</td>
          <td class="item6" v-if="timestamp > item.endTime" @click="endTime()">已结束</td>
        </tr>
      </table>
    </div>
    <div class="content">
      <img src="../assets/array4.png" style="width: 35%;" alt="">
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr class="titleTd " :class="index % 2 ? 'titleTd1' : 'titleTd'" v-for="(item, index) in array4" :key="item.id">
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3">{{ item.activeUserResidue }}</td>
          <td class="item4">{{ item.endDate }}</td>
          <!-- 当前时间在活动开始时间和结束时间之间时，显示“报名” -->
          <td class="item5" v-if="timestamp > item.starTime && timestamp < item.endTime" @click="onApplication(item)">报名
          </td>
          <!-- 当前时间早于活动开始时间时，显示“未开始” -->
          <td class="item6" v-else-if="timestamp < item.starTime" @click="unopened()">未开始</td>
          <!-- 当前时间晚于活动结束时间时，显示“已结束” -->
          <td class="item6" v-else-if="timestamp > item.endTime" @click="endTime()">已结束</td>
        </tr>
      </table>
    </div>
    <div class="buttom">
    </div>
  </div>
</template>

<script>
import { Notify, Dialog } from 'vant';
import { QueryActives } from '../api/forms';
import array1 from '../assets/array1.png'
export default {

  data() {
    return {
      openId: this.$cookies.get("openId") || "",
      meetingList: [],
      // 创建四个空数组
      array1: [],
      array2: [],
      array3: [],
      array4: [],
      timestamp: new Date().getTime(),
    }
  },
  methods: {
    getQueryActives() {
      QueryActives().then((res) => {
        // 遍历原始数据对象
        for (let key in res.data) {
          if (key === '1') {
            this.array1 = res.data[key];
          } else if (key === '2') {
            this.array2 = res.data[key];
          } else if (key === '3') {
            this.array3 = res.data[key];
          } else if (key === '4') {
            this.array4 = res.data[key];
          }
        }
      })
    },
    onApplication(item) {
      //如果剩余名额为0
      if (item.activeUserResidue == 0) {
        Dialog.alert({
          message: "剩余名额已不足，无法报名",
        }).then(() => {
          // on close
        });
      }
      else {
        this.$router.push({
          path: "/form",
          query: {
            openId: this.openId,
            id: item.id,
          },
        });
      }

    },

    //未开启
    unopened() {
      Dialog.alert({
        message: "课程报名未开放",
      }).then(() => {
        // on close
      });
    },

    //已结束
    endTime() {
      Dialog.alert({
        message: "课程已结束",
      }).then(() => {
        // on close
      });
    },
  },
  mounted() {
    this.getQueryActives()
  }
};
</script>
<style lang="scss" scoped>
.formContent {
  background-repeat: repeat;
  background-size: 100% 100%;
  height: 100vh;
  overflow-y: auto;

  .form {
    // min-height: 100vh;
    background: url('../assets/stateTitle.png') no-repeat;
    background-size: 100% auto;
    height: 180px;

    .header {
      text-align: center;
      position: relative;
      padding-top: 36%;
      letter-spacing: 2px;
    }

    .prompt {
      font-size: 11px;
      padding: 0 20px;
      color: #E81A26;
    }
  }

  .content {
    padding: 20px 20px 10px 20px;
    margin: 0 auto;

    img {
      width: 60%;
    }

    .tableTitle {
      margin-top: 10px;
      width: 100%;

      .titleTr {
        white-space: nowrap;
        /* 防止文字换行 */
        font-size: 12px;
        display: flex;
        justify-content: space-evenly;

        th {
          background-color: #E81A26;
          color: #fff;
          border-radius: 10px;
          padding: 3px 10px;
          font-weight: 400;
        }
      }

      .titleTd {
        display: flex;
        align-items: center;
        font-size: 11px;
        background-color: #fff;
        margin: 10px 0;

        td {
          margin-right: 5px;
          padding: 7px 0;

        }

        .item1 {
          width: 22%;
          white-space: nowrap;
        }

        .item2 {
          width: 20%;
          margin-left: 20px;
          white-space: nowrap;
        }

        .item3 {
          width: 18%;
          white-space: nowrap;
        }

        .item4 {
          white-space: nowrap;
          width: 15%;
        }

        .item5 {
          white-space: nowrap;
          color: red;
          font-weight: 800;
        }

        .item6 {
          white-space: nowrap;
          color: #706c6c;
          font-weight: 800;
        }
      }

      .titleTd1 {
        display: flex;
        align-items: center;
        font-size: 11px;
        background-color: #FAFAFA;
        margin: 10px 0;

        td {
          margin-right: 5px;
          padding: 7px 0;

        }

        .item1 {
          width: 22%;
          white-space: nowrap;
        }

        .item2 {
          width: 20%;
          margin-left: 20px;
          white-space: nowrap;
        }

        .item3 {
          width: 18%;
          white-space: nowrap;
        }

        .item4 {
          width: 15%;
          white-space: nowrap;
        }

        .item5 {
          white-space: nowrap;
          color: red;
          font-weight: 800;
        }
      }
    }
  }

  .buttom {
    background: url('../assets/bottom.png') no-repeat;
    background-size: 100% auto;
    height: 150px;
  }
}
</style>